import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { PropType as PolygotPropType } from 'redux-polyglot';
import moment from 'moment-timezone';
import { Row, Col } from 'antd';

import ChartCard from '../Card';
import CapacityGrid from '../Charts/capacityGrid';
import OverCapacity from '../Charts/overCapacity';
import Top10 from '../Charts/top10';
import Panel from './panel';

class RealtimeSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      counter: 0,
      interval: null,
    };
  }

  componentDidMount() {
    this.setState({
      interval: setInterval(this.updateCounter.bind(this), 15 * 2000),
    });
  }

  componentWillUnmount() {
    const { interval } = this.state;
    clearInterval(interval);
  }

  updateCounter() {
    const { counter } = this.state;
    this.setState({ counter: counter + 1 });
  }

  render() {
    const {
      p, orgId, zones, token, isOrgAdmin,
    } = this.props;
    const { counter } = this.state;
    const realtimeProps = {
      p,
      orgId,
      counter,
      zones,
      startDate: moment.utc().add(-65, 'minute').second(counter % 60).format(),
      endDate: moment.utc().add(5, 'minute').second(counter % 60).format(),
      token,
      isOrgAdmin,
    };
    const capacityProps = {
      startDate: moment().startOf('day').second(counter % 60), // TODO: should be timezone aware?
      endDate: moment().clone().endOf('day'),
      p,
      orgId,
      counter,
      zones,
      token,
      isOrgAdmin,
    };
    return (
      <Fragment>
        <Panel {...realtimeProps} />
        <Row span={24} className="summary-row-container">
          <ChartCard hideExport title={p.tt('summary.realtime_capacity_today')}>
            <CapacityGrid isRealtime {...capacityProps} name="summary-realtime-capacity" />
          </ChartCard>
        </Row>
        <Row span={24} gutter={12}>
          <Col span={12}>
            <Top10 isRealtime {...realtimeProps} name="summary-realtime-top10" />
          </Col>
          <Col span={12}>
            <OverCapacity isRealtime {...capacityProps} name="summary-realtime-over-capacity" />
          </Col>
        </Row>
      </Fragment>
    );
  }
}

RealtimeSummary.propTypes = {
  p: PolygotPropType,
  orgId: PropTypes.number,
};

export default RealtimeSummary;
